import { Injectable, inject } from '@angular/core';
import { CommodityDataService } from './commodity-data.service';
import { LocationDataService } from './location-data.service';
import { combineLatest } from 'rxjs';
import { EnvironmentInformationDataService } from './environment-information-data.service';

@Injectable({
    providedIn: 'root',
})
export class PrefetchService {
    private commodityDataService = inject(CommodityDataService);
    private locationDataService = inject(LocationDataService);
    private environmentInformationDataService = inject(
        EnvironmentInformationDataService,
    );

    prefetch() {
        return combineLatest([
            //this.commodityDataService.prefetch(),
            //this.locationDataService.prefetch(),
            this.environmentInformationDataService.prefetch(),
        ]);
    }
}
